import React from "react";
import { CookiesProvider } from "react-cookie";
import { ToastContainer } from "react-toastify";

import { ApolloProvider } from "@apollo/client";
import { IntelligemsThemeProvider } from "@intelligems/ig-theme/theme";
import { StyledEngineProvider } from "@mui/material/styles";
import { useLoadScripts } from "@src/hooks/loadScripts";
import { queryClient } from "@src/queryClient";
import { theme } from "@src/theme";
import { QueryClientProvider } from "@tanstack/react-query";

import { FlaggProvider } from "@intelligems/ig-vendors/flagg/react/provider";

import { Devtools } from "./devtools";
import { featureFlags } from "./feature-flags";

// import "@mui/styles";
import { AppProvider } from "./providers/AppProvider";
import { shopifyGqlClient } from "./providers/gqlProvider";
import { AppRoutes } from "./routes";

import "react-toastify/dist/ReactToastify.css";
import "./App.css";

// declare module "@mui/styles/defaultTheme" {
//   interface DefaultTheme extends Theme {}
// }

export const AppContent = () => {
  useLoadScripts();

  return (
    <QueryClientProvider client={queryClient}>
      <ApolloProvider client={shopifyGqlClient}>
        <StyledEngineProvider injectFirst>
          <IntelligemsThemeProvider theme={theme}>
            {/* @ts-ignore */}
            <CookiesProvider>
              {import.meta.env.DEV && <Devtools />}
              <FlaggProvider featureFlags={featureFlags}>
                <AppProvider>
                  <ToastContainer
                    aria-label="Notifications"
                    closeOnClick={true}
                    autoClose={5000}
                  />
                  <AppRoutes />
                </AppProvider>
              </FlaggProvider>
            </CookiesProvider>
          </IntelligemsThemeProvider>
        </StyledEngineProvider>
      </ApolloProvider>
    </QueryClientProvider>
  );
};
